module.exports = __webpack_public_path__ + "img/douchuan.304ded6d.jpg";